import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackGaPageView } from "../utils/ga4";

let lastTrackedPageKey = null;

export function useAnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    const pageKey = `${location.pathname}${location.search}${location.hash}`;
    if (lastTrackedPageKey === pageKey) return;

    lastTrackedPageKey = pageKey;

    trackGaPageView(location, document.title);
  }, [location]);
}
